// ========================================
// IMPORTS THREE.JS + MODÈLE 3D
// ========================================
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import teteModel from "url:../assets/3D/tete.glb";

// ---------- LOADER ----------
(function loader() {
  const loaderEl = document.getElementById("loader");
  if (!loaderEl) return;

  const currentPage = window.location.pathname;
  const shouldBlock =
    currentPage.includes("contact") || currentPage.includes("works");

  if (shouldBlock) {
    document.body.style.overflow = "hidden";
  }

  loaderEl.classList.add("show");

  window.addEventListener("load", () => {
    setTimeout(() => {
      loaderEl.classList.remove("show");
      document.body.style.overflow = "";
    }, 800);
  });
})();

// ---------- THREE.JS TÊTE 3D ----------
(function initThreeHead() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadThreeModel);
  } else {
    loadThreeModel();
  }

  function loadThreeModel() {
    const container = document.querySelector(".three-container");
    if (!container) return;

    const CONFIG = {
      mouseRotationIntensity: 0.3,
      mouseSmoothness: 0.1,
      autoRotate: false,
      autoRotateSpeed: 0.001,
      cameraDistance: 4,
      modelScale: 2.0,
      modelPath: teteModel,
    };

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      30,
      container.offsetWidth / container.offsetHeight,
      0.1,
      1000,
    );
    camera.position.set(0, 0, CONFIG.cameraDistance);

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(container.offsetWidth, container.offsetHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.setClearColor(0x000000, 0);
    container.appendChild(renderer.domElement);

    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    scene.add(ambientLight);
    const mainLight = new THREE.DirectionalLight(0xffffff, 1.2);
    mainLight.position.set(5, 5, 5);
    scene.add(mainLight);
    const fillLight = new THREE.DirectionalLight(0x4a90e2, 0.4);
    fillLight.position.set(-3, 0, -3);
    scene.add(fillLight);

    let model = null;
    let targetRotationX = 0;
    let targetRotationY = 0;

    window.addEventListener("mousemove", (event) => {
      const mouseX = (event.clientX / window.innerWidth) * 2 - 1;
      const mouseY = -(event.clientY / window.innerHeight) * 2 + 1;
      targetRotationY = mouseX * Math.PI * CONFIG.mouseRotationIntensity;
      targetRotationX =
        -mouseY * Math.PI * (CONFIG.mouseRotationIntensity * 0.4);
    });

    const loader = new GLTFLoader();
    loader.load(
      CONFIG.modelPath,
      (gltf) => {
        model = gltf.scene;
        const box = new THREE.Box3().setFromObject(model);
        const size = box.getSize(new THREE.Vector3());
        const center = box.getCenter(new THREE.Vector3());
        model.position.sub(center);
        const maxDim = Math.max(size.x, size.y, size.z);
        model.scale.setScalar(CONFIG.modelScale / maxDim);
        scene.add(model);
      },
      undefined,
      (error) => console.error("❌ Erreur:", error),
    );

    function animate() {
      requestAnimationFrame(animate);
      if (model) {
        model.rotation.y +=
          (targetRotationY - model.rotation.y) * CONFIG.mouseSmoothness;
        model.rotation.x +=
          (targetRotationX - model.rotation.x) * CONFIG.mouseSmoothness;
        if (CONFIG.autoRotate) model.rotation.y += CONFIG.autoRotateSpeed;
      }
      renderer.render(scene, camera);
    }
    animate();

    window.addEventListener("resize", () => {
      camera.aspect = container.offsetWidth / container.offsetHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(container.offsetWidth, container.offsetHeight);
    });
  }
})();

// ---------- CURSEUR ----------
const cursor = document.querySelector(".cursor");

if (cursor) {
  document.addEventListener("mousemove", (event) => {
    cursor.style.top = event.clientY + "px";
    cursor.style.left = event.clientX + "px";
  });

  document.querySelectorAll("a").forEach((link) => {
    link.addEventListener("mouseenter", () =>
      cursor.classList.add("link-hover"),
    );
    link.addEventListener("mouseleave", () =>
      cursor.classList.remove("link-hover"),
    );
  });
}

// ---------- BURGER MENU ----------
const burger = document.querySelector(".burger");
const icon = document.querySelector(".burger-icon");

if (burger && icon) {
  icon.addEventListener("click", () => {
    burger.classList.toggle("open");
  });
}

// ---------- SLIDER PHOTO ----------
const sliderTrack = document.querySelector(".slider-track");

if (sliderTrack) {
  const slides = Array.from(sliderTrack.children);
  const sliderNext = document.querySelector(".next");
  const sliderPrev = document.querySelector(".prev");
  let sliderIndex = 0;

  function updateSlider() {
    const slideWidth = slides[0].getBoundingClientRect().width;
    sliderTrack.style.transform = `translateX(-${sliderIndex * slideWidth}px)`;
  }

  if (sliderNext) {
    sliderNext.addEventListener("click", () => {
      sliderIndex = (sliderIndex + 1) % slides.length;
      updateSlider();
    });
  }

  if (sliderPrev) {
    sliderPrev.addEventListener("click", () => {
      sliderIndex = (sliderIndex - 1 + slides.length) % slides.length;
      updateSlider();
    });
  }

  let autoSlide = setInterval(() => {
    sliderIndex = (sliderIndex + 1) % slides.length;
    updateSlider();
  }, 4000);

  [sliderNext, sliderPrev].filter(Boolean).forEach((btn) => {
    btn.addEventListener("click", () => {
      clearInterval(autoSlide);
      autoSlide = setInterval(() => {
        sliderIndex = (sliderIndex + 1) % slides.length;
        updateSlider();
      }, 4000);
    });
  });

  updateSlider();
  window.addEventListener("resize", updateSlider);
}

// ---------- CAROUSEL PROJECTS ----------
const carousel = document.querySelector(".recent-carousel");

if (carousel) {
  const cards = Array.from(carousel.children);
  let currentIndex = 0;

  function updateCarousel() {
    cards.forEach((card, index) => {
      card.classList.toggle("is-active", index === currentIndex);
    });

    const activeCard = cards[currentIndex];
    if (!activeCard) return;

    const carouselWidth = carousel.offsetWidth;
    const cardLeft = activeCard.offsetLeft;
    const cardWidth = activeCard.offsetWidth;

    let scrollLeft = cardLeft - (carouselWidth / 2 - cardWidth / 2);
    scrollLeft = Math.max(
      0,
      Math.min(scrollLeft, carousel.scrollWidth - carouselWidth),
    );

    carousel.scrollTo({ left: scrollLeft, behavior: "smooth" });
  }

  function resetAutoScroll() {
    clearInterval(autoScroll);
    autoScroll = setInterval(() => {
      currentIndex = (currentIndex + 1) % cards.length;
      updateCarousel();
    }, 4000);
  }

  let autoScroll = setInterval(() => {
    currentIndex = (currentIndex + 1) % cards.length;
    updateCarousel();
  }, 4000);

  const nextBtn = document.querySelector(".carousel-next");
  const prevBtn = document.querySelector(".carousel-prev");

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      currentIndex = (currentIndex + 1) % cards.length;
      updateCarousel();
      resetAutoScroll();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      currentIndex = (currentIndex - 1 + cards.length) % cards.length;
      updateCarousel();
      resetAutoScroll();
    });
  }

  carousel.addEventListener(
    "wheel",
    (e) => {
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
        e.preventDefault();
        carousel.scrollLeft += e.deltaY;
      }
    },
    { passive: false },
  );

  updateCarousel();
}

// ---------- BRANCH SECTIONS — PARALLAX ----------
(function branchParallax() {
  const sections = document.querySelectorAll("[data-branch]");
  if (!sections.length) return;

  const RATE = 0.35;

  function update() {
    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      const progress = (vh - rect.top) / (vh + rect.height);
      const centered = (progress - 0.5) * 2;
      const offset = centered * rect.height * RATE * 0.2;
      const imageWrap = section.querySelector(".branch-section__image-wrap");
      if (imageWrap) imageWrap.style.transform = `translateY(${offset}px)`;
    });
    requestAnimationFrame(update);
  }

  requestAnimationFrame(update);
})();

// ---------- INDEX HERO PARALLAX ----------
(function heroParallax() {
  const section = document.querySelector(".index-main");
  if (!section) return;

  const h1 = section.querySelector("h1");
  const p = section.querySelector("p");

  function update() {
    const scrollY = window.scrollY;
    const sectionHeight = section.offsetHeight;
    const progress = Math.min(scrollY / sectionHeight, 1);

    if (h1) {
      h1.style.transform = `translateY(${-progress * 80}px)`;
      h1.style.opacity = 1 - progress * 1.5;
    }
    if (p) {
      p.style.transform = `translateY(${-progress * 40}px)`;
      p.style.opacity = 1 - progress * 2;
    }

    requestAnimationFrame(update);
  }

  requestAnimationFrame(update);
})();

// ---------- SCROLL REVEAL ----------
(function scrollReveal() {
  const revealElements = document.querySelectorAll(
    [
      ".index-title",
      ".recent-card",
      ".slider",
      ".branch-section",
      ".btn-here",
      ".card",
      ".works-project-h1",
      ".works-project-p",
      ".works-project-image-left",
      ".works-project-image-center",
      ".works-project-image-duo",
      ".works-project-image-trio",
      ".works-project-image-trio2",
      ".works-project-image-right",
      ".card-full",
      ".project-card",
      ".project-card",
      ".works-grid",
      ".works-filters",
      ".about-img",
      ".about-p",
    ].join(", "),
  );

  requestAnimationFrame(() => {
    revealElements.forEach((el) => el.classList.add("sr-hidden"));

    setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("sr-visible");
              entry.target.classList.remove("sr-hidden");
            } else {
              if (entry.boundingClientRect.top > 0) {
                entry.target.classList.remove("sr-visible");
                entry.target.classList.add("sr-hidden");
              }
            }
          });
        },
        { threshold: 0.1, rootMargin: "0px 0px -40px 0px" },
      );

      revealElements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.remove("sr-hidden");
          return;
        }
        observer.observe(el);
      });
    }, 50);
  });
})();

// ---------- PIXEL CURSOR ----------
const PIXEL_CURSOR_CONFIG = {
  tiltX: 18,
  tiltY: 18,
  scaleOnMove: 1.1,
  lerpSpeed: 0.12,
  offsetX: 8,
  offsetY: 4,
};

const PixelCursor = (() => {
  const el = document.getElementById("pixel-cursor");
  const img = document.getElementById("pixel-cursor__img");
  const zones = document.querySelectorAll("[data-pixel-cursor]");

  if (!el || !img || !zones.length) return;

  let isActive = false;
  let rafId = null;
  const mouse = { x: 0, y: 0 };
  const current = { x: 0, y: 0 };
  const velocity = { x: 0, y: 0 };
  const prevMouse = { x: 0, y: 0 };

  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

  function tick() {
    rafId = requestAnimationFrame(tick);

    current.x = lerp(current.x, mouse.x, PIXEL_CURSOR_CONFIG.lerpSpeed);
    current.y = lerp(current.y, mouse.y, PIXEL_CURSOR_CONFIG.lerpSpeed);

    velocity.x = lerp(velocity.x, mouse.x - prevMouse.x, 0.2);
    velocity.y = lerp(velocity.y, mouse.y - prevMouse.y, 0.2);
    prevMouse.x = mouse.x;
    prevMouse.y = mouse.y;

    const rotY = clamp(
      velocity.x * PIXEL_CURSOR_CONFIG.tiltY * 0.4,
      -PIXEL_CURSOR_CONFIG.tiltY,
      PIXEL_CURSOR_CONFIG.tiltY,
    );
    const rotX = clamp(
      -velocity.y * PIXEL_CURSOR_CONFIG.tiltX * 0.4,
      -PIXEL_CURSOR_CONFIG.tiltX,
      PIXEL_CURSOR_CONFIG.tiltX,
    );
    const rotZ = clamp(velocity.x * 0.6, -12, 12);
    const speed = Math.sqrt(velocity.x ** 2 + velocity.y ** 2);
    const scaleFactor = lerp(
      1,
      PIXEL_CURSOR_CONFIG.scaleOnMove,
      Math.min(speed / 20, 1),
    );

    el.style.transform = `translate(${current.x + PIXEL_CURSOR_CONFIG.offsetX}px, ${current.y + PIXEL_CURSOR_CONFIG.offsetY}px)`;
    img.style.transform = `perspective(600px) rotateX(${rotX}deg) rotateY(${rotY}deg) rotateZ(${rotZ}deg) scale(${scaleFactor})`;
  }

  function onMouseMove(e) {
    mouse.x = e.clientX;
    mouse.y = e.clientY;
  }

  function onEnterZone() {
    if (isActive) return;
    isActive = true;
    current.x = mouse.x;
    current.y = mouse.y;
    el.classList.add("is-active");
    if (!rafId) tick();
  }

  function onLeaveZone() {
    isActive = false;
    el.classList.remove("is-active");
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    img.style.transform = "";
  }

  document.addEventListener("mousemove", onMouseMove, { passive: true });
  zones.forEach((zone) => {
    zone.addEventListener("mouseenter", onEnterZone);
    zone.addEventListener("mouseleave", onLeaveZone);
  });
  document.addEventListener("mouseleave", onLeaveZone);

  return { config: PIXEL_CURSOR_CONFIG };
})();

// ---------- BTN HERE ----------
const BtnHere = (() => {
  const CONFIG = {
    maxRX: 16,
    maxRY: 22,
    scaleHover: 1.05,
    scaleDefault: 1,
    lerpHover: 0.11,
    lerpReset: 0.065,
    perspective: 700,
    globalInfluence: 0.18,
  };

  const btn = document.getElementById("btnHere");
  const spot = document.getElementById("btnHereSpot");
  const video = document.getElementById("btnHereVideo");
  if (!btn || !spot) return;

  let isHovered = false;
  let rafId = null;
  const target = { rx: 0, ry: 0, scale: CONFIG.scaleDefault };
  const cur = { rx: 0, ry: 0, scale: CONFIG.scaleDefault };
  const lerp = (a, b, t) => a + (b - a) * t;

  function tick() {
    const spd = isHovered ? CONFIG.lerpHover : CONFIG.lerpReset;
    cur.rx = lerp(cur.rx, target.rx, spd);
    cur.ry = lerp(cur.ry, target.ry, spd);
    cur.scale = lerp(cur.scale, target.scale, spd);

    btn.style.transform = `perspective(${CONFIG.perspective}px) rotateX(${cur.rx}deg) rotateY(${cur.ry}deg) scale(${cur.scale})`;

    const sx = cur.ry * 0.6;
    const sy = -cur.rx * 0.6;
    const sb = 24 + Math.abs(cur.ry) * 0.8;
    btn.style.boxShadow = `${sx}px ${sy + 8}px ${sb}px rgba(0,0,0,0.55), 0 2px 4px rgba(0,0,0,0.4)`;

    const atRest =
      !isHovered &&
      Math.abs(cur.rx) < 0.01 &&
      Math.abs(cur.ry) < 0.01 &&
      Math.abs(cur.scale - CONFIG.scaleDefault) < 0.001;
    if (atRest) {
      cancelAnimationFrame(rafId);
      rafId = null;
      btn.style.transform = "";
      btn.style.boxShadow =
        "0 8px 24px rgba(0,0,0,0.4), 0 2px 4px rgba(0,0,0,0.3)";
      return;
    }
    rafId = requestAnimationFrame(tick);
  }

  const start = () => {
    if (!rafId) rafId = requestAnimationFrame(tick);
  };

  document.addEventListener(
    "mousemove",
    (e) => {
      if (isHovered) return;
      const rect = btn.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      target.ry =
        ((e.clientX - cx) / (window.innerWidth / 2)) *
        CONFIG.maxRY *
        CONFIG.globalInfluence;
      target.rx =
        -((e.clientY - cy) / (window.innerHeight / 2)) *
        CONFIG.maxRX *
        CONFIG.globalInfluence;
      start();
    },
    { passive: true },
  );

  btn.addEventListener("mouseenter", () => {
    isHovered = true;
    target.scale = CONFIG.scaleHover;
    start();
    if (video) {
      video.currentTime = 0;
      video.play().catch(() => {});
    }
  });

  btn.addEventListener("mouseleave", () => {
    isHovered = false;
    target.scale = CONFIG.scaleDefault;
    spot.style.opacity = "0";
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });

  btn.addEventListener(
    "mousemove",
    (e) => {
      const rect = btn.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      target.ry = ((e.clientX - cx) / (rect.width / 2)) * CONFIG.maxRY;
      target.rx = -((e.clientY - cy) / (rect.height / 2)) * CONFIG.maxRX;
      spot.style.left = e.clientX - rect.left + "px";
      spot.style.top = e.clientY - rect.top + "px";
      spot.style.opacity = "1";
    },
    { passive: true },
  );
})();

// ---------- SCROLL INDICATOR ----------
(function scrollIndicator() {
  const indicator = document.querySelector(".scroll-indicator--bottom");
  if (!indicator) return;

  window.addEventListener(
    "scroll",
    () => {
      if (window.scrollY > 10) indicator.classList.add("is-hidden");
    },
    { passive: true },
  );
})();
// ---------- WORKS FILTER ----------
// ---------- WORKS FILTER ----------
const filterBtns = document.querySelectorAll(".filter-btn");
const workCards = document.querySelectorAll(".works-grid .project-card");

if (filterBtns.length && workCards.length) {
  filterBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const filter = btn.dataset.filter;

      filterBtns.forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");

      workCards.forEach((card) => {
        const match = filter === "all" || card.dataset.category === filter;
        if (match) {
          card.classList.remove("is-hidden");
        } else {
          card.classList.add("is-hidden");
        }
      });
    });
  });
}
